// extracted by mini-css-extract-plugin
export default {"wrapper":"PrivateContentLoader_wrapper--s4V"};